import ashutoshshah from "./AshutoshShah.png";
import ruchinarain from "./RuchiNarain.png";
import tahershabbir from "./TaherShabbir.png";

export const founderAssets = {
  ashutoshshah,
  ruchinarain,
  tahershabbir,
};
